import { useTickets } from "../../../contexts/TicketContext";
import { Icon } from "@iconify/react/dist/iconify.js";

export const NewTickets = ({ tickets: propTickets }) => {
    const { tickets: contextTickets } = useTickets();
    const tickets = propTickets || contextTickets;
    const newTicketsThisWeek = tickets.filter(ticket => {
        const ticketDate = new Date(ticket.createdTime);
        const oneWeekAgo = new Date();
        oneWeekAgo.setDate(oneWeekAgo.getDate() - 7);
        return ticketDate >= oneWeekAgo;
    }).length;

    return(
        <div className="flex flex-col items-start justify-between w-full h-full p-4 card-container rounded-md gap-2">
            <p className="text-font-secondary whitespace-nowrap text-lg">New Tickets this Week</p>
            <div className="flex flex-row items-center justify-between w-full">
                <div className="flex flex-row items-center justify-between gap-1">
                    <Icon icon="material-symbols-light:update-rounded" className="text-4xl text-primary"></Icon>
                    <p className="text-2xl font-bold text-font-secondary">{newTicketsThisWeek}</p>
                </div>
                <p className="text-lg whitespace-nowrap text-font-secondary text-base">
                    <span className="text-xl text-primary font-bold">+{newTicketsThisWeek}</span> from Yesterday
                </p>
            </div>
        </div>
    );
}
